import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Blog from "./pages/Blog";
import BlogArticle from "./pages/BlogArticle";
import ChronicPain from "./pages/ChronicPain";
import ConditionPage from "./pages/ConditionPage";
import AboutUs from "./pages/AboutUs";
import FAQPage from "./pages/FAQPage";
import TransferClinic from "./pages/TransferClinic";
import HowItWorksPage from "./pages/HowItWorksPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ZeroTolerance from "./pages/ZeroTolerance";
import AccessibilityStatement from "./pages/AccessibilityStatement";
import Terms from "./pages/Terms";
import Complaints from "./pages/Complaints";
import SitemapPage from "./pages/SitemapPage";
import NotFound from "./pages/NotFound";
import PatientRejoiningPolicy from "./pages/PatientRejoiningPolicy";
import { Toaster } from "./components/ui/sonner";
import MobileBottomBar from "./components/MobileBottomBar";

function App() {
  useEffect(() => {
    document.title = "Integro Clinics | Medical Cannabis Clinic UK";
  }, []);

  return (
    <div className="App relative">
      <BrowserRouter basename={process.env.REACT_APP_BASENAME || "/"}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/chronic-pain" element={<ChronicPain />} />
          <Route path="/conditions/:conditionId" element={<ConditionPage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/transfer-clinic" element={<TransferClinic />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/zero-tolerance-policy" element={<ZeroTolerance />} />
          <Route path="/accessibility-statement" element={<AccessibilityStatement />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/complaints" element={<Complaints />} />
          <Route path="/sitemap" element={<SitemapPage />} />
          <Route path="/patient-rejoining-policy" element={<PatientRejoiningPolicy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <MobileBottomBar />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
